import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { CDN_TYPE_GAME, imageUrlCDN } from 'utils';

import { Slider } from '@atlas/components';
import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Label } from '@atlas/ui';

import history from 'components/MainRouter/history';
import { useIsRtl } from 'src/hooks/useIsRtl';

const ProvidersBlockSlider = ({
  onProviderClick = () => {},
  propSliderSettings = { rows: 2 },
  providers,
}) => {
  const casinoPath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.CASINO);
  const isRtl = useIsRtl();
  const { rows } = propSliderSettings;

  const sliderConfig = useMemo(
    () => ({
      dir: isRtl ? 'rtl' : 'ltr',
      grid: {
        fill: 'row',
        rows: rows,
      },
    }),
    [isRtl, rows],
  );

  const onClickHandler = useCallback(
    provider => {
      onProviderClick();
      history.push(`${casinoPath}?providerNames=${provider.name}`);
    },
    [casinoPath, onProviderClick],
  );
  return (
    <Slider
      autoplay={false}
      breakpointsBase="container"
      className="casino-providers-block__slider"
      dir={sliderConfig.dir}
      grid={sliderConfig.grid}
      loop={false}
      spaceBetween={7}
    >
      {providers.map(provider => (
        <Slider.Slide key={provider.id}>
          <div
            className="provider-card casino-providers-block__slider-item"
            onClick={() => onClickHandler(provider)}
          >
            {provider?.iconUrl && (
              <img
                alt={provider.providerName}
                className="provider-card__img"
                loading="lazy"
                src={`${imageUrlCDN(provider.iconUrl, CDN_TYPE_GAME)}`}
              />
            )}
            {!provider?.iconUrl && (
              <Label className="provider-card__name" message={provider.displayedName} />
            )}
          </div>
        </Slider.Slide>
      ))}
    </Slider>
  );
};

export default ProvidersBlockSlider;

ProvidersBlockSlider.propTypes = {
  onProviderClick: PropTypes.func,
  propSliderSettings: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.number),
  }),
  providers: PropTypes.array.isRequired,
};
